/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useRef } from 'react';

import { usePageNavigation } from 'bundles/unified-description-page-common/contexts/PageNavigationContext';

type Props = {
  children: React.ReactNode;
  anchorId?: string;
  spacing?: number;
};

const styles = {
  section: (spacing: number, fixedPageNavHeight?: number) => css`
    margin: ${spacing}px 0;
    scroll-margin-top: ${fixedPageNavHeight ? fixedPageNavHeight + 24 : 132}px;
  `,
};

const Section = React.forwardRef(({ children, anchorId, spacing = 48 }: Props, ref?: React.Ref<HTMLDivElement>) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  const { addSectionElementRef, fixedPageNavHeight } = usePageNavigation();

  useEffect(() => {
    if (sectionRef.current && addSectionElementRef && anchorId) {
      addSectionElementRef(anchorId, sectionRef.current);
    }
  }, [addSectionElementRef, anchorId]);

  return (
    <div css={styles.section(spacing, fixedPageNavHeight)} id={anchorId} ref={sectionRef}>
      <div ref={ref}>{children}</div>
    </div>
  );
});

export default Section;
